import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";

import { Rating } from "@/components/Product/Rating/rating.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

export type EmptyRatingSummaryComponentProps = {
    writeReview: () => void;
    goToReviews: () => void;
};

const EmptyRatingSummaryComponent = ({
    writeReview,
    goToReviews
}: EmptyRatingSummaryComponentProps) => {
    const { t } = useGranite();

    return (
        <div className={cn("tw:flex tw:items-center tw:gap-4")}>
            <Button
                size={"sm"}
                color={"link"}
                className={cn("tw:inline-flex tw:gap-4 tw:p-0")}
                onClick={goToReviews}
            >
                <Rating
                    value={0}
                    size={16}
                />
                <div>{`(0)`}</div>
            </Button>
            <div>
                <Button
                    size={"sm"}
                    color={"link"}
                    className={cn("tw:p-0")}
                    aria-label={t("general.reviews.write.aria")}
                    onClick={writeReview}
                >
                    {t("general.reviews.write")}
                </Button>
            </div>
        </div>
    );
};

export { EmptyRatingSummaryComponent };
